export default {
  setDevice(state, val) {
    state.device = val;
  },

  setCategory(state, val) {
    state.category = val;
  },

  setStickers(state, val) {
    state.stickers = val;
  },

  setThemes(state, val) {
    state.themes = val;
  },

  setDevices(state, val) {
    state.devices = val;
  },

  setManufacturer(state, val) {
    state.manufacturer = val;
  },

  clearAll(state) {
    state.device = null;
    state.category = null;
    state.stickers = null;
    state.themes = null;
    state.manufacturer = null;
    state.devices = null;
  },
};
